import _extends from '@babel/runtime/helpers/extends';
import React__default, { Children, isValidElement, cloneElement } from 'react';
import styled, { css } from 'styled-components';
import { i as isMobile } from '../../theme/style-mixins/isMobile/isMobile-CGsYoba7.js';
import { I as InputLabel } from '../../InputLabel/InputLabel-DkkiEzm3.js';

const StyledLegend = /*#__PURE__*/styled(InputLabel).withConfig({
  componentId: "sc-storm-ui-40026394__sc-tgsbuj-0"
})(["margin-bottom:", ";", ""], ({
  theme
}) => theme.controls.blockLabelGapLg.default, isMobile(css(["margin-bottom:", ";"], ({
  theme
}) => theme.controls.blockLabelGapLg.mobile)));
const Item = /*#__PURE__*/styled('div').withConfig({
  componentId: "sc-storm-ui-40026394__sc-tgsbuj-1"
})(["word-wrap:break-word;width:100%;", ""], isMobile(css(["border-bottom:", ";&& > label{min-width:", ";padding:", ";}&&:first-of-type{border-top-left-radius:", ";border-top-right-radius:", ";}&&:last-of-type{border-bottom-left-radius:", ";border-bottom-right-radius:", ";border-bottom:none;}"], ({
  theme
}) => theme.border.subtle.default, ({
  theme
}) => theme.checkboxGroup.minWidth.mobile, ({
  theme
}) => theme.spacing.xsmall.mobile, ({
  theme
}) => theme.border.radius.large, ({
  theme
}) => theme.border.radius.large, ({
  theme
}) => theme.border.radius.large, ({
  theme
}) => theme.border.radius.large)));
Item.displayName = 'CheckboxGroupItem';
const ItemsContainer = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-storm-ui-40026394__sc-tgsbuj-2"
})(["display:flex;box-sizing:border-box;flex-direction:column;gap:", ";width:fit-content;", " ", ""], ({
  theme
}) => theme.spacing.xxsmall.default, ({
  $groupIndicator
}) => $groupIndicator === 'bar' ? css(["border-inline-start:", ";padding-inline-start:", ";margin-inline-start:", ";"], ({
  theme
}) => theme.border.subtle.default, ({
  theme
}) => theme.spacing.small.default, ({
  theme
}) => theme.spacing.xxsmall.default) : undefined, isMobile(css(["gap:0;background-color:", ";border:", ";border-radius:", ";display:block;padding-inline-start:unset;margin-inline-start:unset;width:100%;"], ({
  theme
}) => theme.surface.default, ({
  theme
}) => theme.border.subtle.default, ({
  theme
}) => theme.border.radius.large)));
ItemsContainer.displayName = 'CheckboxGroupItemsContainer';
const FieldSet = /*#__PURE__*/styled.fieldset.withConfig({
  componentId: "sc-storm-ui-40026394__sc-tgsbuj-3"
})(["border:none;margin:0;padding:0;margin-block-start:unset;margin-block-end:unset;margin-inline-start:unset;margin-inline-end:unset;padding-inline-start:unset;"]);
FieldSet.displayName = 'CheckboxGroupFieldSet';
const CheckboxGroup = ({
  children,
  className,
  disabled,
  hideLabel,
  label,
  groupIndicator = 'none',
  ...rest
}) => children && /*#__PURE__*/React__default.createElement(FieldSet, _extends({
  className: className,
  disabled: disabled
}, rest), /*#__PURE__*/React__default.createElement(StyledLegend, {
  renderAs: "legend",
  disabled: disabled,
  hidden: hideLabel
}, label), /*#__PURE__*/React__default.createElement(ItemsContainer, {
  $groupIndicator: groupIndicator
}, Children.map(children, child => {
  /* Only set disabled when the child is react Element */
  if (/*#__PURE__*/isValidElement(child)) {
    return /*#__PURE__*/React__default.createElement(Item, null, /*#__PURE__*/cloneElement(child, {
      ...child.props,
      disabled: disabled || child.props.disabled,
      size: 'base'
    }));
  }
  return child;
})));
CheckboxGroup.displayName = 'CheckboxGroup';

export { CheckboxGroup as C };
//# sourceMappingURL=CheckboxGroup-CqmNpyt5.js.map
